module.exports = __webpack_public_path__ + "img/funnel-bpd-2021.d2675426.svg";